const WebRTCRecordingStreamConstants = {
    defaultWebrtcRecordingResolutions: 'medium',
    webrtcRecordingResolution: 'webrtc_recording_resolution',
    webrtcRecordingFPS: 'webrtc_recording_fps',
    webrtcRecordingResolutions: {
        low: { videoWidth: 360, videoHeight: 240 },
        medium: { videoWidth: 640, videoHeight: 480 },
        high: { videoWidth: 1280, videoHeight: 720 },
    },
    defaultWebRtcWebCamFpsForRecordingStream: 15,
    defaultWebRtcWebCamFpsForRecorder: 1,
    enhancedWebRTCRecorderFPS: 15,
};

export default WebRTCRecordingStreamConstants;
